import {
  Component,
  ElementRef,
  InputSignal,
  input,
  WritableSignal,
  signal,
  inject,
} from '@angular/core';

@Component({
  selector: 'aw-table-cell',
  templateUrl: './table-cell.component.html',
})
export class TableCellComponent<T> {
  public readonly cellName: InputSignal<string> = input.required();

  public readonly element: ElementRef = inject(ElementRef);

  public readonly isCellVisible: WritableSignal<boolean> = signal(true);

  public hideCell(): void {
    this.element.nativeElement.style.display = 'none';
    this.isCellVisible.set(false);
  }
  public showCell(): void {
    this.element.nativeElement.style.display = 'inherit';
    this.isCellVisible.set(true);
  }
}
